import {SmartComponent} from "smart-component-js";
import Utility from "./Utility";

class CheckRedirectComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.init();
    }

    init() {
        // authProvider è disponibile solo dopo il caricamento asincrono del modulo raas (head.jsp)
        window.authProviderReady
            .then((authProvider) => authProvider.auth.getLoginStatus())
            .then(
                () => {},
                () => this.redirectError()
            );
    }


    redirectError() {
        const urlKoParam = Utility.getUrlParameter('urlKo');
        if (!urlKoParam) return;
        const urlKo = new URL(urlKoParam, window.location.origin);
        if (urlKo.protocol === 'http:' || urlKo.protocol === 'https:') window.location.href = urlKo.href;
    }
}

export default CheckRedirectComponent;
